import {useTranslation} from "react-i18next";
import FlintCheckBox from "@components/controls/FlintCheckBox";
import FlintLabel from "@components/controls/FlintLabel";
import {useState} from "react";
import FlintTextBox from "@components/controls/FlintTextBox";
import FlintEditor from "@components/controls/FlintEditor";
import {SendMassiveEmailRequest} from "@pages/administration/mailings/emaillist.models";
import FlintButton from "@components/controls/FlintButton";
import {ApiResponseDto, BasePopupProps, NameWithId} from "@utils/Models";
import axios from "axios";
import {ApiUrl_EmailSender_SendMassiveEmail} from "@utils/Endpoints";
import {useFlintNotificationContext} from "@components/page_components/common/notifications/FlintNotificationContext";
import {useNavigate, useParams} from "react-router-dom";
import FlintLoadingWrapper from "@components/page_components/common/loading/FlintLoadingWrapper";


export default function SendEmailPopup(props: SendEmailPopupProps) {
    const {t} = useTranslation();
    const {state, handlers} = useSendEmailPopup(props);
    
    return (
        <FlintLoadingWrapper showLoading={state.isLoading.get}>
            <div>
                <div className={"alert alert-info text-center"}>
                    {t("infoSystemEmail")}
                </div>
                <FlintLabel className={"title-label"}>{t("MAILING_SelectGroups")}</FlintLabel>
                <div className={"row row-cols-4"}>
                    <div className={"col"}>
                        <FlintCheckBox label={t("USER_FILTER_Customers")}
                                       value={state.model.get.SendToCustomers}
                                       onChange={x => state.model.set("SendToCustomers", x.value)}/>
                    </div>
                    <div className={"col"}>
                        <FlintCheckBox label={t("USER_FILTER_Employees")}
                                       value={state.model.get.SendToEmployees}
                                       onChange={x => state.model.set("SendToEmployees", x.value)}/>
                    </div>
                    <div className={"col"}>
                        <FlintCheckBox label={t("USER_FILTER_Supervisors")}
                                       value={state.model.get.SendToSupervisors}
                                       onChange={x => state.model.set("SendToSupervisors", x.value)}/>
                    </div>
                    <div className={"col"}>
                        <FlintCheckBox label={t("USER_FILTER_Admins")}
                                       value={state.model.get.SendToAdmins}
                                       onChange={x => state.model.set("SendToAdmins", x.value)}/>
                    </div>
                </div>
                <div className={"form-group"}>
                    <FlintTextBox required={true} label={t("lblSubject")}
                                  value={state.model.get.EmailSubject}
                                  onChange={x => state.model.set("EmailSubject", x.value)}/>
                </div>
                <div className={"form-group"}>
                    <FlintEditor useSimpleToolbox={true}
                                 value={state.model.get.EmailBody}
                                 onChange={x => state.model.set("EmailBody", x.html)}/>
                </div>
                <div className={"btn-zone text-center gap-3 d-flex justify-content-center"}>
                    <FlintButton themeColor={"secondary"}
                                 onClick={props.OnCancelled}>{t("Cancel")}</FlintButton>
                    <FlintButton themeColor={"primary"}
                                 onClick={handlers.handleConfirmed}>{t("Confirm")}</FlintButton>

                </div>
            </div>
        </FlintLoadingWrapper>
    );
}

export interface SendEmailPopupProps extends BasePopupProps<NameWithId> {

}

function useSendEmailPopup(props: SendEmailPopupProps) {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {showNotification} = useFlintNotificationContext();
    const [model, setModel] = useState<SendMassiveEmailRequest>({
        SendToAdmins: false,
        SendToCustomers: false,
        SendToEmployees: false,
        SendToSupervisors: false,
        EmailSubject: "",
        EmailBody: ""
    });

    function updateModel<T extends keyof SendMassiveEmailRequest>(key: T, value: SendMassiveEmailRequest[T]) {
        setModel(prev => ({
            ...prev,
            [key]: value
        }))
    }

    function handleConfirmed() {
        if (!model.EmailSubject) {
            alert("Subject can not be empty");
            return;
        }
        if (!model.EmailBody) {
            alert("Message body can not be empty");
            return;
        }
        if (!model.SendToCustomers && !model.SendToEmployees && !model.SendToSupervisors && !model.SendToAdmins) {
            alert("Select at least one group of recipients");
            return;
        }
        setIsLoading(true);
        return axios.post<ApiResponseDto<NameWithId>>(ApiUrl_EmailSender_SendMassiveEmail, model)
            .then(response => {
                props.OnConfirmedAndSaved(response.data.Result);
            })
            .catch(error => {
                showNotification(error)
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    return {
        state: {
            isLoading: {get: isLoading},
            model: {get: model, set: updateModel},
        },
        utils: {

            visibility: {},
        },
        handlers: {
            handleConfirmed,
        },
    };
}
